/**
 * Imperative "this action was refused" dialog, mirroring the toast service:
 * any slice or thunk can call blockedAction.show(...) and the host mounted in
 * App renders it. Used for rule refusals the user must read — e.g. a delete
 * turned down because active contracts still use the record — which a
 * three-second banner is too easy to miss.
 */
export interface BlockedActionItem {
  title?: string;
  message: string;
}

type Listener = (item: BlockedActionItem | null) => void;

let listeners: Listener[] = [];
let current: BlockedActionItem | null = null;

function notify() {
  listeners.forEach((l) => l(current));
}

export const blockedAction = {
  show(item: BlockedActionItem) {
    current = item;
    notify();
  },

  dismiss() {
    current = null;
    notify();
  },

  subscribe(fn: Listener) {
    listeners.push(fn);
    fn(current);
    return () => {
      listeners = listeners.filter((l) => l !== fn);
    };
  },
};
